import { UnitCategory } from '../types/units';

type PopularConversion = {
  from: string;
  to: string;
  url: string;
};

export const popularConversions: Record<UnitCategory, PopularConversion[]> = {
  length: [
    // Metric to Imperial
    { from: 'kilometer', to: 'mile', url: 'km-to-miles' },
    { from: 'meter', to: 'foot', url: 'meters-to-feet' },
    { from: 'centimeter', to: 'inch', url: 'cm-to-inches' },
    { from: 'millimeter', to: 'inch', url: 'mm-to-inches' },
    
    // Imperial to Metric
    { from: 'mile', to: 'kilometer', url: 'miles-to-km' },
    { from: 'foot', to: 'meter', url: 'feet-to-meters' },
    { from: 'inch', to: 'centimeter', url: 'inches-to-cm' },
    { from: 'yard', to: 'meter', url: 'yards-to-meters' },
    
    // Common Metric
    { from: 'meter', to: 'kilometer', url: 'meters-to-km' },
    { from: 'centimeter', to: 'meter', url: 'cm-to-meters' },
    { from: 'millimeter', to: 'centimeter', url: 'mm-to-cm' },
    
    // Common Imperial
    { from: 'mile', to: 'foot', url: 'miles-to-feet' },
    { from: 'yard', to: 'foot', url: 'yards-to-feet' },
    { from: 'foot', to: 'inch', url: 'feet-to-inches' }
  ],
  weight: [
    // Metric to Imperial
    { from: 'kilogram', to: 'pound', url: 'kg-to-lbs' },
    { from: 'gram', to: 'ounce', url: 'grams-to-ounces' },
    { from: 'kg', to: 'st', url: 'kg-to-stone' },
    { from: 'g', to: 'lb', url: 'grams-to-pounds' },
    
    // Imperial to Metric
    { from: 'pound', to: 'kilogram', url: 'lbs-to-kg' },
    { from: 'ounce', to: 'gram', url: 'ounces-to-grams' },
    { from: 'st', to: 'kg', url: 'stone-to-kg' },
    
    // Common Metric
    { from: 'kg', to: 'g', url: 'kg-to-grams' },
    { from: 'g', to: 'mg', url: 'grams-to-mg' },
    { from: 'mg', to: 'ug', url: 'mg-to-ug' },
    
    // Common Imperial
    { from: 'st', to: 'lb', url: 'stone-to-lbs' },
    { from: 'lb', to: 'oz', url: 'lbs-to-ounces' },
    { from: 'ton_us', to: 'lb', url: 'tons-to-lbs' }
  ],
  data: [
    // Common storage conversions
    { from: 'mb', to: 'kb', url: 'mb-to-kb' },
    { from: 'gb', to: 'mb', url: 'gb-to-mb' },
    { from: 'tb', to: 'gb', url: 'tb-to-gb' },
    { from: 'kb', to: 'mb', url: 'kb-to-mb' },
    { from: 'mb', to: 'gb', url: 'mb-to-gb' },
    { from: 'gb', to: 'tb', url: 'gb-to-tb' },
    
  ],
  temperature: [
    // Common Conversions
    { from: 'celsius', to: 'fahrenheit', url: 'celsius-to-fahrenheit' },
    { from: 'fahrenheit', to: 'celsius', url: 'fahrenheit-to-celsius' },
    { from: 'celsius', to: 'kelvin', url: 'celsius-to-kelvin' },
    { from: 'kelvin', to: 'celsius', url: 'kelvin-to-celsius' },
    { from: 'fahrenheit', to: 'kelvin', url: 'fahrenheit-to-kelvin' },
    { from: 'kelvin', to: 'fahrenheit', url: 'kelvin-to-fahrenheit' },
    
    // Scientific Conversions
    { from: 'celsius', to: 'rankine', url: 'celsius-to-rankine' },
    { from: 'rankine', to: 'celsius', url: 'rankine-to-celsius' },
    { from: 'celsius', to: 'reaumur', url: 'celsius-to-reaumur' },
    { from: 'reaumur', to: 'celsius', url: 'reaumur-to-celsius' },
    { from: 'celsius', to: 'delisle', url: 'celsius-to-delisle' },
    { from: 'delisle', to: 'celsius', url: 'delisle-to-celsius' }
  ],
  cooking: [
    // Volume Conversions
    { from: 'cup', to: 'milliliter', url: 'cups-to-ml' },
    { from: 'tablespoon', to: 'milliliter', url: 'tablespoons-to-ml' },
    { from: 'teaspoon', to: 'milliliter', url: 'teaspoons-to-ml' },
    
    // Common US to Metric
    { from: 'cup', to: 'liter', url: 'cups-to-liters' },
    { from: 'gallon', to: 'liter', url: 'gallons-to-liters' },
    { from: 'quart', to: 'liter', url: 'quarts-to-liters' },
    { from: 'pint', to: 'milliliter', url: 'pints-to-ml' },
    
    // Common Metric to US
    { from: 'liter', to: 'cup', url: 'liters-to-cups' },
    { from: 'liter', to: 'gallon', url: 'liters-to-gallons' },
    { from: 'milliliter', to: 'tbsp', url: 'ml-to-tablespoons' },
    { from: 'milliliter', to: 'tsp', url: 'ml-to-teaspoons' },
    
    // Common Cooking Conversions
    { from: 'cup', to: 'tbsp', url: 'cups-to-tablespoons' },
    { from: 'tbsp', to: 'tsp', url: 'tablespoons-to-teaspoons' },
    { from: 'cup', to: 'floz', url: 'cups-to-fluid-ounces' }
  ],
  time: [
    // Common Time Conversions
    { from: 'hour', to: 'minute', url: 'hours-to-minutes' },
    { from: 'minute', to: 'second', url: 'minutes-to-seconds' },
    { from: 'day', to: 'hour', url: 'days-to-hours' },
    { from: 'week', to: 'day', url: 'weeks-to-days' },
    
    // Larger to Smaller Units
    { from: 'year', to: 'month', url: 'years-to-months' },
    { from: 'month', to: 'day', url: 'months-to-days' },
    { from: 'year', to: 'day', url: 'years-to-days' },
    { from: 'day', to: 'minute', url: 'days-to-minutes' },
    
    // Smaller to Larger Units
    { from: 'minute', to: 'hour', url: 'minutes-to-hours' },
    { from: 'second', to: 'minute', url: 'seconds-to-minutes' },
    { from: 'hour', to: 'day', url: 'hours-to-days' },
    { from: 'day', to: 'week', url: 'days-to-weeks' },
    
    // Milliseconds Conversions
    { from: 'millisecond', to: 'second', url: 'milliseconds-to-seconds' },
    { from: 'second', to: 'millisecond', url: 'seconds-to-milliseconds' }
  ],
  energy: [
    // Common Energy Conversions
    { from: 'j', to: 'cal', url: 'joules-to-calories' },
    { from: 'cal', to: 'j', url: 'calories-to-joules' },
    { from: 'kwh', to: 'j', url: 'kwh-to-joules' },
    { from: 'j', to: 'kwh', url: 'joules-to-kwh' },
    
    // Food Energy
    { from: 'cal', to: 'kcal', url: 'calories-to-kcal' },
    { from: 'kcal', to: 'j', url: 'kcal-to-joules' },
    
    // Mechanical Energy
    { from: 'j', to: 'ft_lb', url: 'joules-to-foot-pounds' },
    { from: 'btu', to: 'j', url: 'btu-to-joules' }
  ],
  pressure: [
    // Common Pressure Conversions
    { from: 'psi', to: 'bar', url: 'psi-to-bar' },
    { from: 'bar', to: 'psi', url: 'bar-to-psi' },
    { from: 'kpa', to: 'psi', url: 'kpa-to-psi' },
    { from: 'psi', to: 'kpa', url: 'psi-to-kpa' },
    
    // Atmospheric Pressure
    { from: 'atm', to: 'bar', url: 'atm-to-bar' },
    { from: 'bar', to: 'atm', url: 'bar-to-atm' },
    { from: 'mmhg', to: 'kpa', url: 'mmhg-to-kpa' },
    { from: 'inhg', to: 'kpa', url: 'inhg-to-kpa' }
  ],
  speed: [
    // Common Speed Conversions
    { from: 'mph', to: 'kph', url: 'mph-to-kph' },
    { from: 'kph', to: 'mph', url: 'kph-to-mph' },
    { from: 'mps', to: 'kph', url: 'mps-to-kph' },
    { from: 'fps', to: 'mps', url: 'fps-to-mps' },
    
    // Maritime and Aviation
    { from: 'knot', to: 'mph', url: 'knots-to-mph' },
    { from: 'knot', to: 'kph', url: 'knots-to-kph' },
    { from: 'mach', to: 'mph', url: 'mach-to-mph' },
    { from: 'mach', to: 'kph', url: 'mach-to-kph' }
  ],
  angle: [
    // Common Angle Conversions
    { from: 'deg', to: 'rad', url: 'degrees-to-radians' },
    { from: 'rad', to: 'deg', url: 'radians-to-degrees' },
    { from: 'deg', to: 'grad', url: 'degrees-to-gradians' },
    { from: 'grad', to: 'deg', url: 'gradians-to-degrees' },
    
    // Navigation and Surveying
    { from: 'deg', to: 'mil', url: 'degrees-to-mils' },
    { from: 'mil', to: 'deg', url: 'mils-to-degrees' },
    { from: 'arcmin', to: 'deg', url: 'arcminutes-to-degrees' },
    { from: 'arcsec', to: 'deg', url: 'arcseconds-to-degrees' }
  ],
  frequency: [
    // Common Frequency Conversions
    { from: 'hz', to: 'khz', url: 'hz-to-khz' },
    { from: 'khz', to: 'mhz', url: 'khz-to-mhz' },
    { from: 'mhz', to: 'ghz', url: 'mhz-to-ghz' },
    
    // Audio Frequencies
    { from: 'hz', to: 'rpm', url: 'hz-to-rpm' },
    { from: 'rpm', to: 'hz', url: 'rpm-to-hz' }
  ],
  // Add more categories as needed...
}; 